import React, { Component } from 'react'
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../../actions/documentUploadActions';
import * as constant from '../../../constants/constant';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AppointmentDocs from '../../sitemanagement/appointmentDocs';
import $ from "jquery";
import './../../../styles/css/newDocument.css'
import * as dashboardActions from "../../../actions/dashboardActions";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import highres from './../../../images/highres.png'
import arrow from './../../../images/arrow3.png'
import clear from './../../../images/clear.png'
import fileformat from './../../../images/fileformat.png'
import fullpage from './../../../images/fullpage.png'
import upload from './../../../images/upload.png'
import fakeCert from './../../../images/fakeCert.jpg'
import Upload from './../../miniComponents/FileUpload'
import DeleteIcon from '@material-ui/icons/Delete';



export class ProofOfPracticingClinic extends Component {

    constructor(props) {
        super(props)
        console.log(this.props.popcData._id)
        this.state = {
             images : [],
             documentName: this.props.popcData.name,
             documentId: this.props.popcData._id,
             docTypeId: this.props.popcData.id,
             docAndStatus: [],
             docStatuses: []
        }
        this.updateImages = this.updateImages.bind(this)
        this.deleteFiles = this.deleteFiles.bind(this)
        this.uploadFiles = this.uploadFiles.bind(this)
    }
    

    componentWillReceiveProps(nextProps){
        console.log(nextProps)
    
		if (nextProps.success) {
			this.setState({
                specialistDocument: nextProps.specialistDocument?nextProps.specialistDocument.docs: [] ,
				totalCount: nextProps.totalCount,
				isLoader: false,
				docAndStatus: nextProps.docAndStatus? nextProps.docAndStatus: [],
				docStatuses: nextProps.docTypes && nextProps.docTypes.specialistInfo?nextProps.docTypes.specialistInfo:{}
            })
            

            // if(nextProps.specialistDocument){
            //     for(let i = 0; i< nextProps.specialistDocument.length; i++){
            //         if(nextProps.specialistDocument[i].name=="Proof of Education"){
                        
            //             this.setState({
            //                 documentId: nextProps.specialistDocument[i]._id,
            //                 docTypeId: (nextProps.specialistDocument[i].id).toString()
            //             })
            //         }
            //     }
            // }

		} 
    
    }


    updateImages(newImages){
        console.log(newImages)
        let state = this.state
        state.images=newImages
        this.setState(state,()=>{
            console.log(this.state.images)
        })
        
    }

    deleteFiles(index){
        let state = this.state
        state.images.splice(index,1)
        this.setState(state,()=>{
            console.log(this.state.images)
        })
    }

    uploadFiles(){
        let objDoc = {
		
			userId: localStorage.getItem('userId'),
            documentName: this.state.documentName,
            documentTypeId: this.props.popcData._id,
            docTypeId: "E",
			file: this.state.images
        }
        console.log(objDoc)
        this.props.actions.uploadSpecialistDocument(objDoc)
        setTimeout(()=>{
            this.props.goBack()
        },1000)
    }



    render() {
        return (
            <CardContent style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',padding: '0px'}}>
                                     


                                    
                                
        
                    <Card style={{width: '100%'}}>

                        <CardContent className="poe">
                            <Row className="card-head">
                                <img src={arrow} height="50" onClick={this.props.goBack}/>

                                <Typography variant="h4" style={{marginTop:0}}>Proof Of Practicing Clinic</Typography>
                                
                            </Row>



                            <Row className="poe-first">
                            <Col lg={{ size: 6}}>
                                <div className="dd">

                                    <div>
                                        <Upload 
                                        refresh={this.updateImages}
                                        
                                        />

                                        <div style={{position: 'absolute',zIndex:'500'}}>

                                        <img src={upload} height="80" />
                                    <p>Drag files in here</p>
                                    <p>Or</p>
                                    <button className="btn btn-square w-50">Browse Files</button>
                                    <small>Upload upto 20 files. Max file size 2 MB.</small>
                                        </div>
                             
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} className="filesToBeUploaded">
                                <div style={{display:'flex',flexDirection:'column',flex:1,maxHeight: '350px',overflowY:'scroll'}}>
        {this.state.images && this.state.images.map((im, index)=><div className="uploadItems" key={index}>
            
            
            <p>{im.name}</p> <p onClick={(e)=>this.deleteFiles(index)}><DeleteIcon style={{color: '#8e867c'}}/></p>
            
            </div>)}</div>

            {this.state.images.length>0 &&
            <div style={{display:'flex',justifyContent:'center',marginTop:'auto'}}>
            <button className="btn btn-square w-50" onClick={this.uploadFiles}>Upload Files</button></div> }
                            </Col>

                            </Row>

                            <Row className="poe-second">
                            <Col lg={6}>
                                <Typography variant="h4">Proof Of Practicing Clinic</Typography>
                                <p>Please provide a valid proof of clinic ownership. This can include partial or full time ownership.</p>
                            
                            <p>Ownership documentation must be a valid agreement or contract.</p>

                            <p>If you're unsure about clinic ownership, you may submit any one (1) of these alternative options:</p>
                            <li>Letterhead OR prescription pad with owner signature and statement indicating partial or full ownership of the clinic.</li>
                            <li>Proof of clinic registration OR business tax receipt.</li>
                            </Col>

                            <Col lg={6} className="cert" style={{height:"100%",display: 'flex',justifyContent:'center',alignItems:'center',maxWidth:"80%",padding: '15px'}}>
                            <img src={fakeCert} height="300px" width="auto"/>
                            </Col>

                            </Row>




                            <Row className="poe-third">
                            <Col lg={12}>
                                <Typography variant="h4">Tips For Uploading Documents</Typography>
                                <p>Please ensure the following document tips are followed for successful verification procedures.</p>

                            </Col>
                            <Col lg={6}>
                                <img src={highres} height="30"/>
                                <h5>High Resolution</h5>
                                <p>Clear and legible scans or images</p>
                            </Col>
                            <Col lg={6}>
                                <img src={fullpage} height="30"/>
                                <h5>Full Page Visual</h5>
                                <p>Include all 4 edges of the document in the image (no cut-off portions of your document)</p>
                            </Col>
                            <Col lg={6}>
                                <img src={clear} height="30"/>
                                <h5>Upload clear & legible images</h5>
                                <p>Take well-lit clear and bright pictures of your document. Text must be easy to read. Allow your camera to focus avoiding blur and glare.</p>
                            </Col>
                            <Col lg={6}>
                                <img src={fileformat} height="30"/>
                                <h5>Accepted file formats</h5>
                                <p>Please upload PDF, JPEG or PNG formats.</p>
                            </Col>


                            </Row>


                            

                     

                        </CardContent>


                    </Card>

            








             </CardContent>
        )
    }
}


function mapStateToProps(state, ownProps) {
	return {
		specialistDocument: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument : [],
		totalCount: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.totalCount : 0,
		success: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.success : false,
		isProfileSaved: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isProfileSaved : false,
		isVettingTriggered: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isVettingTriggered : false,
		documentTypes: state.uploadDocument.userTypeData,
		uploadedSpecialistData: state.uploadDocument.uploadedSpecialistData,
		specialistDocumentData: state.uploadDocument.specialistDocumentData,
        docAndStatus: state.uploadDocument.docAndStatus,
		docTypes: state.uploadDocument.docTypes
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ProofOfPracticingClinic);